import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import { LandingPage } from '@/components/LandingPage'

export function RootPage() {
  const { isAuthenticated, isLoading } = useAuthStore()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-700 mx-auto mb-4"></div>
          <p className="text-slate-600">Loading...</p>
        </div>
      </div>
    )
  }

  // Show landing page for unauthenticated users
  if (!isAuthenticated) {
    return <LandingPage />
  }

  // Redirect authenticated users to dashboard
  return <Navigate to="/dashboard" replace />
}
